









































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import { Group } from "@/models/groups/group.model";
import GroupService from "@/services/group.service";
import List from "@/components/list.vue";
import { pushNotification } from "@/utils/utils";
import { ENotificationType } from "@/models/enums";
import { StreamInfo } from "@/models/groups/streamInfo.model";
import { GroupDeviceInfo } from "@/models/groups/groupDeviceInfo.model";

@Component({
  components: {
    DashboardTemplate,
    List,
  },
})

export default class DataStreams extends Vue {
  private updateRootGroup: boolean = false;
  private dialogVisibleAddStream = false;
  private dialogVisibleAddDevice = false;
  private rootGroup: Group = new Group(null);
  private loading: boolean = true;
  private addStreamForm: StreamInfo | null = null;
  private addDeviceForm: GroupDeviceInfo | null = null;
  private addStreamRules = {
    url: [
      { required: true, message: "Please enter a Url", trigger: "blur" }
    ]
  };
  private editGroupRules = {
    name: [
      { required: true, message: "Please enter a name", trigger: "blur" }
    ]
  };
  private addDeviceRules = {
    serialNumber: [
      { required: true, message: "Please enter a serial number", trigger: "blur" }
    ]
  };
  private async mounted() {
    this.rootGroup = await GroupService.getRootGroup();
    this.addStreamForm = new StreamInfo({
      headerName: "",
      headerValue: "",
    });
    this.addDeviceForm = new GroupDeviceInfo({
      serialNumber: "",
    });
    this.loading = false;
  }
  private get getGroupDevices() {
    return this.rootGroup.devices.map((d) => ({serialNumber: d}));
  }
  @Watch("rootGroup.name", { deep: true, immediate: true })
  private onRoutGroupModeChanged(oldData: any, newData: any) {
    if (newData !== undefined && newData !== oldData) {
      this.updateRootGroup = true;
    }
  }
  private async handleAddStream(object: StreamInfo) {
    (this.$refs.addStreamForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.dialogVisibleAddStream = false;
        await GroupService.addStreamToGroup(object, this.rootGroup.id);
      }
    });
  }
  private async handleAddDevice(device: GroupDeviceInfo) {
    (this.$refs.addDeviceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.dialogVisibleAddDevice = false;
        await GroupService.addDeviceToGroup(device.serialNumber, this.rootGroup.id);
      }
    });
  }
  private async handleDeleteStreams(stream: StreamInfo) {
    await GroupService.deleteStreamFromGroup(stream.id, this.rootGroup.id);
  }
  private async handleDeleteDevices(device: GroupDeviceInfo) {
    await GroupService.deleteDeviceFromGroup(device.serialNumber, this.rootGroup.id);
  }
  private async handleUpdateGroup(group: Group) {
    (this.$refs.updateGroupForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await GroupService.updateGroup(group);
      }
    });
  }
}
